import React from 'react';

import { useTranslation } from "react-i18next";

import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';

const QuickActions = (props) => {

    const { t } = useTranslation();

    const inputParam_Display = props.display !== null && props.display !== undefined ?  props.display : false;
    
    const handleOptionClick = (url) => {
        //history.push(url, { clientId: item.id })
    }
    return (
        <OverflowSet
            className={`action-menu-list-toolbar d-flex justify-content-center ${inputParam_Display ? "d-unset" : "d-none"}`}
            role="menubar"      
            items={[
                {
                    key: 'item1',
                    icon: 'RedEye',
                    name: t('data-lang-pagename-1'),
                    title: t('data-lang-pagename-1'),
                    onClick: () => handleOptionClick("/profileclient"),
                },
                {
                    key: 'item2',
                    icon: 'Message',
                    name: t('data-lang-pagename-2'),
                    title: t('data-lang-pagename-2'),
                    onClick: () => handleOptionClick("/editclient"),
                },
                {
                    key: 'item3',
                    icon: 'Group',
                    name: t('data-lang-pagename-3'),
                    title: t('data-lang-pagename-3'),
                    onClick: () => handleOptionClick("/manageproducts"),
                },
                {
                    key: 'item4',
                    icon: "PollResults",
                    name: t('data-lang-pagename-4'),
                    title: t('data-lang-pagename-4'),
                    onClick: () => handleOptionClick("/managepermissions"),
                },
                {
                    key: 'item5',
                    icon: "DocumentManagement",
                    name: t('data-lang-pagename-5'),
                    title: t('data-lang-pagename-5'),
                    onClick: () => handleOptionClick("/managepermissions"),
                },
                {
                    key: 'item6',
                    icon: "Equalizer",
                    name: t('data-lang-pagename-6'),
                    title: t('data-lang-pagename-6'),
                    onClick: () => handleOptionClick("/managepermissions"),
                },
                {
                    key: 'item7',
                    icon: "TextCallout",
                    name: t('data-lang-pagename-7'),
                    title: t('data-lang-pagename-7'),
                    onClick: () => handleOptionClick("/managepermissions"),
                },
                {
                    key: 'item8',
                    icon: "CheckList",
                    name: t('data-lang-pagename-8'),
                    title: t('data-lang-pagename-8'),
                    onClick: () => handleOptionClick("/managepermissions"),
                },
                {
                    key: 'item9',
                    icon: "BarChartVertical",
                    name: t('data-lang-pagename-9'),
                    title: t('data-lang-pagename-9'),
                    onClick: () => handleOptionClick("/managepermissions"),
                },
            ]}
            onRenderOverflowButton={__onRenderOverflowButton}
            onRenderItem={__onRenderOverflowItem}
        />
    )
}
export default QuickActions